import { type FormItemProps } from 'antd/es/form';
import { FieldArray } from 'formik';
import { get } from 'lodash/fp';
import FormItem from '../../../../components/fields/FormItem';
import { type ImageDescriptionBlockInput, type WebpageFormikValue } from '../shared';
import ImageTable from './ImageTable';

export interface ImageDescriptionInputArrayProps {
    name: string;
    label?: string;
    labelForAdd?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
    limit?: number;
    disabled?: boolean;
}

const ImageDescriptionBlock = ({
    name,
    label,
    labelForAdd,
    itemProps,
    limit,
    disabled = false,
    ...props
}: ImageDescriptionInputArrayProps) => (
    <FormItem {...itemProps} label={label} name={name}>
        <FieldArray
            name={name}
            render={arrayHelpers => {
                const webpage = arrayHelpers.form.values as WebpageFormikValue;
                const webpageImage = get(name, webpage) as ImageDescriptionBlockInput[];

                return (
                    <ImageTable
                        disabled={disabled}
                        imageTable={webpageImage}
                        name={name}
                        remove={arrayHelpers.remove}
                    />
                );
            }}
        />
    </FormItem>
);

export default ImageDescriptionBlock;
